import React from 'react';
import '../styles/Footer.scss';

export const Footer = () => {
  return (
    <></>
  );
}; 